// extracted by mini-css-extract-plugin
module.exports = {"placeholderStyle":"PasswordInputTwo_placeholderStyle__9DPLc","inputStyle":"PasswordInputTwo_inputStyle__1284S"};